module.exports = __webpack_public_path__ + "img/IMG-20230301-WA0020.1c85d15e.jpg";